<template>
	<FieldSet :label="label" :infoText="infoText" :required="required">
		<SalesChannelSelector
			ref="selector"
			:modelValue="modelValue"
			:clients="clients"
			:propClientAssignments="propClientAssignments"
			:serviceProvider="serviceProvider"
			:dataCy="dataCy"
			:app="app"
			:clientAssignmentLocked="clientAssignmentLocked"
			:salesChannelSelectionLocked="salesChannelSelectionLocked"
			:isWaiting="isWaiting"
			:locked="locked"
			@update:modelValue="$emit('update:modelValue', $event)"
		/>
	</FieldSet>
</template>

<script>
import FieldSet from '../../views/applications/packageDesigner/FieldSet.vue'
import SalesChannelSelector from './SalesChannelSelector.vue'

export default {
	name: 'SalesChannelsSection',
	components: { FieldSet, SalesChannelSelector },
	props: {
		label: String,
		infoText: String,
		required: Boolean,
		modelValue: Array,
		clients: Array,
		propClientAssignments: Array,
		serviceProvider: Object,
		dataCy: String,
		app: String,
		clientAssignmentLocked: Boolean,
		salesChannelSelectionLocked: Boolean,
		isWaiting: Boolean,
		locked: Boolean,
	},
	emits: ['update:modelValue'],
	methods: {
		// AAL-86 Copilot: the nested selector holds the home Client rule
		allowsUncheckingHomebase() {
			return this.$refs.selector?.allowsUncheckingHomebase?.() === true
		},
	},
}
</script>
